import {createUseStyles} from "react-jss";
import {useState, useEffect} from "react";

import TopOfPage from "./sections/TopOfPage";
import AboutMe from "./sections/AboutMe";
import CareerObjective from "./sections/CareerObjective";
import Education from "./sections/Education";
import TechnicalWork from "./sections/TechnicalWork";
import TechnicalSkills from "./sections/TechnicalSkills";
import CreativeEndeavors from "./sections/CreativeEndeavors";
import WorkExperience from "./sections/WorkExperience";
import styles from "./Style";
import useMobile from "../../template/Mobile";
const useStyles = createUseStyles(styles);


const portfolio = [{ sectionName : "Top of Page", sectionComponent: <TopOfPage/> },
    { sectionName : "About Me", sectionComponent: <AboutMe/> },
    // { sectionName : "Career Objective", sectionComponent : <CareerObjective/> },
    { sectionName : "Education", sectionComponent : <Education/> },
    { sectionName : "Technical Work", sectionComponent : <TechnicalWork/> },
    // { sectionName : "Technical Skills", sectionComponent : <TechnicalSkills/> },
    { sectionName : "Creative Endeavors", sectionComponent : <CreativeEndeavors/> },
    { sectionName : "Work Experience", sectionComponent : <WorkExperience/> }]

export default function Portfolio() {
    const style = useStyles();
    const isMobile = useMobile();

    const [currentSection, setCurrentSection] = useState(portfolio[0].sectionName);

    const handleScroll = () => {
        const topOfPage = document.getElementById(portfolio[0].sectionName)
        let closestSection = topOfPage ? topOfPage : null;
        let found = false;
        portfolio.forEach((item) => {
            if (found) return;
            const element = document.getElementById(item.sectionName)
            const yPosition = element?.getBoundingClientRect().top;
            if (closestSection === null ||  yPosition < window.innerHeight/3) {
                closestSection = element;
                if (yPosition >= -5) {
                    found = true;
                }
            }
        })
        setCurrentSection(closestSection.id);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return <div className={style.fullPage}>
        <title>Portfolio - Thomas Galletta</title>
        <header>

        </header>
        <div className={style.pageMainContentContainer}>
            { isMobile ? null : <div className={style.portfolioSidebar}>
                <h2>Jump to...</h2>
                {
                    portfolio.map((item) => (
                        <button
                            className={item.sectionName === currentSection ? style.currentSidebarJumpToSectionButton : style.sidebarJumpToSectionButton}
                            onClick={() => {
                                const element = document.getElementById(item.sectionName)
                                element?.scrollIntoView({behavior: 'smooth'})
                            }}>{item.sectionName}</button>
                    ))
                }
                </div>
            }
            <div className={style.portfolioContent}>
                {
                    portfolio.map((item, index) => (
                        <div key={index} id={item.sectionName} className={style.portfolioContentSection}>
                            {
                                index > 0 ? <div>
                                    <div className={style.horizontalBreak}/>
                                    <h2 className={style.portfolioSectionHeader}>{item.sectionName}</h2>
                                </div> : null
                            }
                            {item.sectionComponent}
                        </div>
                    ))
                }
            </div>
        </div>
    </div>
}